const settingsActionTypes = {
  SET_THEME: 'SET_THEME',
  SET_APP: 'SET_APP',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
};

export default settingsActionTypes;
